// AUTO GENERATED FILE. DO NOT EDIT.
  import PageOrApp from 'tenants/_app'

  export { reportWebVitals } from 'tenants/_app';
         import '@teko/ds-desktop/dist/ds-desktop.css';
      

  
  export default PageOrApp;